import { Box, Button, Stack, Text } from '@mantine/core';
import React from 'react';

import { useOrganizationConfig } from '@portals/api/organizations';

import { ReactComponent as Lock } from '../../assets/img/403.svg';

export function Page403() {
  const organizationConfig = useOrganizationConfig();

  const adminEmail = organizationConfig?.admin_user_email || '';

  return (
    <Stack
      align="center"
      justify="center"
      h="100%"
      w="50%"
      m="auto"
      spacing={0}
    >
      <Box mb="xl">
        <Lock />
      </Box>
      <Text size="md" align="center" c="gray.8" weight={600} mb="xs">
        Access Restricted
      </Text>
      <Text size="sm" align="center" c="gray.5" weight={600} mb="md">
        You currently do not have sufficient permissions to access any space.
        Please contact your administrator for further assistance and to request
        additional permissions.
      </Text>

      <Button component="a" href={`mailto:${adminEmail}`}>
        Contact Admin
      </Button>
    </Stack>
  );
}
